export default function () {
	document.addEventListener('DOMContentLoaded', function() {

		//Pokud je radio button v boxu s borderem a tomu dáme class radio-cont
		//tak při vybrání se obarví border barvou definovanou v highlight-border
		const radios = document.querySelectorAll('.radio-cont .form-check-input');
		if (radios.length > 0) {
			radios.forEach(function(radio) {
				radio.addEventListener('change', function() {
					const parent = radio.closest('.radio-cont');
					if (parent) {
						if (radio.checked) {
							parent.classList.add('highlight-border');
							radios.forEach(function(otherRadio) {
								if (otherRadio !== radio && otherRadio.name === radio.name) {
									otherRadio.closest('.radio-cont').classList.remove('highlight-border');
								}
							});
						}
					}
				});
			});
		}
		//To samé pro checkboxy - stačí obalováku dát check-cont classu
		function highlightParent(check) {
			const parent = check.closest('.check-cont');
			if (parent) {
				if (check.checked) {
					parent.classList.add('highlight-border');
				} else {
					parent.classList.remove('highlight-border');
				}
			}
		}
		const checks = document.querySelectorAll('.check-cont .form-check-input');
		if (checks.length > 0) {
			checks.forEach(function(check) {
				highlightParent(check);

				check.addEventListener('change', function() {
					highlightParent(check);
				});
			});
		}
	});
}
